import React from 'react';
import OfferInterface from 'interfaces/offer.interface';
import Box from 'atomic/utilization/box';
import Link from 'atomic/utilization/link';
import Price from 'atomic/utilization/price';
import Stars from 'atomic/utilization/stars';
import Button from 'atomic/utilization/button';
import scrollTop from 'helpers/scroll-page';
import { offersSort } from 'helpers/offers-sort';
import { useSelector } from '@ecommerce/nest-ssr/common';
import { OffersState, SortType } from '../../../reducers/offers';

import './box-best-offers.desktop.scss';

const BoxBestOffersDesktop: React.FC = () => {
    const offersFinal = useSelector((state: { offers: OffersState; }) => [...state.offers.items]).sort(offersSort(SortType.Price));

    if (offersFinal.length === 0) {
        return null;
    }

    return (
        <Box title="Najtańsze oferty" titlePosition="center" className="box-best-offers hidden"
            anchorIdName="box-best-offers" headerTitle={true}
        >
            <ul>
                {
                    offersFinal.slice(0, 5).map((offer: OfferInterface) => (
                        <li key={offer.id} className="box-best-offers__item hidden">
                            <Link
                                className="box-best-offers__item__link gtm_tdrl"
                                rel="noreferrer nofollow noopener"
                                href={offer.url}
                                target="_blank"
                                title="Przejdź do oferty"
                            >
                                <div className="box-best-offers__item__link-logo">
                                    {offer.dealer.logo
                                        ? (
                                            <img src={offer.dealer.logo} alt={offer.dealer.name} height={30}/>
                                        )
                                        : (
                                            <div className="box-best-offers__item__link-logo-text">
                                                {offer.dealer.name}
                                            </div>
                                        )}
                                </div>
                                {offer.dealer.opinions && offer.dealer.opinions.count > 0 && (
                                    <div className="box-best-offers__item__link-opinions">
                                        <Stars className="xs" width={offer.dealer.opinions.average}/>
                                        (
                                        {offer.dealer.opinions.count}
                                        )
                                    </div>
                                )}
                                <div className="box-best-offers__item__link-button">
                                    <Button color="orange">
                                        <Price price={offer.price} weight="500" size="md"
                                            color="white"
                                        />
                                        <i className="icon-arr2-right"/>
                                    </Button>
                                </div>
                            </Link>
                        </li>
                    ))
                }
            </ul>
            <div className="box__footer">
                <Link href="#ceny" onClick={scrollTop} className="link"
                    uppercase={true} weight="600" block={true}
                >
                    Więcej ofert
                </Link>
            </div>
        </Box>
    );
};

export default BoxBestOffersDesktop;
